import './polyfills';
import { SmartOfficeNavigation } from './SmartOfficeNavigation';

(window as any).SmartOfficeNavigation = SmartOfficeNavigation;
